export default __webpack_public_path__ + "static/media/step2.f44533f4.webp";